export default __webpack_public_path__ + "static/media/2_fooddiary__september.e45b976a.jpg";